import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export default function AccessDenied() {
  const [params] = useSearchParams();
  const { logout } = useAuth0();

  const description =
    params.get('error_description') || 'You are not authorized to use this application.';

  return (
    <div style={{ padding: 24 }}>
      <h1>Access denied</h1>
      <p>{decodeURIComponent(description)}</p>

      <div style={{ marginTop: 16 }}>
        <button
          onClick={() =>
            logout({
              logoutParams: { returnTo: `${window.location.origin}/login` },
            })
          }
        >
          Log out
        </button>
      </div>

      {/* 👇 DEV ONLY: token verification */}
      {process.env.NODE_ENV === 'development' && (
        <div style={{ marginTop: 24 }}>
          <DebugTokenButton />
        </div>
      )}

      <p style={{ marginTop: 16 }}>
        <Link to="/login">Back to login</Link>
      </p>
    </div>
  );
}

export function DebugTokenButton() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  return (
    <button
      onClick={async () => {
        try {
          const token = await getAccessTokenSilently({
            authorizationParams: {
              audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            },
          });
          // token retrieved (dev debug only)
        } catch (e) {
          // token request failed (expected for denied user)
        }
      }}
    >
      Debug: Get Access Token
    </button>
  );
}
